module.exports = __webpack_public_path__ + "img/OpportunityHub.ff923d87.svg";